export default {
  GET_COMMENTS_SUCCESS: 'GET_COMMENTS_SUCCESS',
  GET_COMMENTS_LOADING: 'GET_COMMENTS_LOADING',
  GET_COMMENTS_REJECT: 'GET_COMMENTS_REJECT',
  GET_COMMENTS_FAILED: 'GET_COMMENTS_FAILED',

  FETCH_USER_COMMENTS_SUCCESS: 'FETCH_USER_COMMENTS_SUCCESS',
  FETCH_USER_COMMENTS_LOADING: 'FETCH_USER_COMMENTS_LOADING',
  FETCH_USER_COMMENTS_REJECT: 'FETCH_USER_COMMENTS_REJECT',
  FETCH_USER_COMMENTS_FAILED: 'FETCH_USER_COMMENTS_FAILED',

  REPLY_TO_CUSTOMER_COMMENT_SUCCESS: 'REPLY_TO_CUSTOMER_COMMENT_SUCCESS',
  REPLY_TO_CUSTOMER_COMMENT_LOADING: 'REPLY_TO_CUSTOMER_COMMENT_LOADING',
  REPLY_TO_CUSTOMER_COMMENT_REJECT: 'REPLY_TO_CUSTOMER_COMMENT_REJECT',
  REPLY_TO_CUSTOMER_COMMENT_FAILED: 'REPLY_TO_CUSTOMER_COMMENT_FAILED',

  CLEAR_REPLY_TO_CUSTOMER_COMMENT: 'CLEAR_REPLY_TO_CUSTOMER_COMMENT',
  CLEAR_EDIT_RESPONSE_COMMENT_FORM: 'CLEAR_EDIT_RESPONSE_COMMENT_FORM',
  INIT_USER_COMMENTS_LIST: 'INIT_USER_COMMENTS_LIST',
  INIT_COMMENTS_LIST: 'INIT_COMMENTS_LIST',

  UPDATE_COMMENT_STATUS_FAILED: 'UPDATE_COMMENT_STATUS_FAILED',
  UPDATE_COMMENT_STATUS_REJECT: 'UPDATE_COMMENT_STATUS_REJECT',
  UPDATE_COMMENT_STATUS_SUCCESS: 'UPDATE_COMMENT_STATUS_SUCCESS',
  UPDATE_COMMENT_STATUS_LOADING: 'UPDATE_COMMENT_STATUS_LOADING',

  SAVE_PREV_COMMENTS_LIST: 'SAVE_PREV_COMMENTS_LIST',
  SAVE_PREV_USER_COMMENTS_LIST: 'SAVE_PREV_USER_COMMENTS_LIST',

  EDIT_RESPONSE_COMMENT_SUCCESS: 'EDIT_RESPONSE_COMMENT_SUCCESS',
  EDIT_RESPONSE_COMMENT_LOADING: 'EDIT_RESPONSE_COMMENT_LOADING',
  EDIT_RESPONSE_COMMENT_REJECT: 'EDIT_RESPONSE_COMMENT_REJECT',
  EDIT_RESPONSE_COMMENT_FAILED: 'EDIT_RESPONSE_COMMENT_FAILED',

  CHANGE_CAFE_ACCESS_TO_RESPONSE_SUCCESS: 'CHANGE_CAFE_ACCESS_TO_RESPONSE_SUCCESS',
  CHANGE_CAFE_ACCESS_TO_RESPONSE_LOADING: 'CHANGE_CAFE_ACCESS_TO_RESPONSE_LOADING',
  CHANGE_CAFE_ACCESS_TO_RESPONSE_FAILED: 'CHANGE_CAFE_ACCESS_TO_RESPONSE_FAILED',
  CHANGE_CAFE_ACCESS_TO_RESPONSE_REJECT: 'CHANGE_CAFE_ACCESS_TO_RESPONSE_REJECT',
};
